/* 导出自定义拖拽指令 */
export const draggable = {
  bind(el) {
    let windowWidth = window.innerWidth
    let windowHeight = window.innerHeight
    let dragging = false
    let offsetX = 0
    let offsetY = 0

    // 鼠标按下时，记录位置
    const onMouseDown = (e) => {
      dragging = true
      offsetX = e.clientX - el.getBoundingClientRect().left
      offsetY = e.clientY - el.getBoundingClientRect().top
    }

    // 鼠标移动时，拖动元素
    const onMouseMove = (e) => {
      if (dragging) {
        // 阻止点击事件
        e.preventDefault()
        document.body.style.userSelect = 'none' // 防止文本被选中
        if (!el.getAttribute('data-dragging')) {
          el.setAttribute('data-dragging', true)
        }
        // 计算元素新的位置
        let newLeft = e.clientX - offsetX
        let newTop = e.clientY - offsetY

        // 限制元素不超出窗口
        newLeft = Math.max(0, Math.min(newLeft, windowWidth - el.offsetWidth))
        newTop = Math.max(0, Math.min(newTop, windowHeight - el.offsetHeight))

        // 更新元素的位置
        el.style.left = `${newLeft}px`
        el.style.top = `${newTop}px`
      }
    }

    // 鼠标松开时，停止拖动
    const onMouseUp = (e) => {
      dragging = false
      document.body.style.userSelect = '' // 恢复文本选择

      setTimeout(() => {
        el.removeAttribute('data-dragging')
      })
    }

    // 窗口缩放区域更新区域
    const onResize = () => {
      windowWidth = window.innerWidth
      windowHeight = window.innerHeight
      const _left = el.offsetLeft
      const _top = el.offsetTop
      if (_left > windowWidth - 100) {
        el.style.left = `${windowWidth - 100}px`
      }
      if (_top > windowHeight - 100) {
        el.style.top = `${windowHeight - 100}px`
      }
    }

    // 绑定事件
    el.addEventListener('mousedown', onMouseDown)
    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)

    window.addEventListener('resize', onResize)
    // 在 el 上存储事件处理函数，便于 unbind 时移除
    el.__vueDraggableHandlers = { onMouseDown, onMouseMove, onMouseUp, onResize }
  },

  unbind(el) {
    // 移除事件监听器
    const { onMouseDown, onMouseMove, onMouseUp, onResize } = el.__vueDraggableHandlers || {}
    if (onMouseDown) el.removeEventListener('mousedown', onMouseDown)
    if (onMouseMove) document.removeEventListener('mousemove', onMouseMove)
    if (onMouseUp) document.removeEventListener('mouseup', onMouseUp)
    if (onResize) window.removeEventListener('resize', onResize)

    // 清除事件处理函数
    delete el.__vueDraggableHandlers
  }
}
